import React, { useEffect, useState } from 'react';
import api from '../services/api';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Reportes: React.FC = () => {
  const [pagosFiltrados, setPagosFiltrados] = useState<any[]>([]);
  const [clientes, setClientes] = useState<any[]>([]);
  const [morosos, setMorosos] = useState<any[]>([]);
  const [clientesParaCorte, setClientesParaCorte] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [mesFiltro, setMesFiltro] = useState(() => new Date().toISOString().slice(0,7));

  const hoy = new Date();
  const diaHoy = hoy.getDate();
  const esReporteDia8 = diaHoy >= 8;

  const cargarPagosMes = async () => {
    setLoading(true);
    try {
      const [anio, mes] = mesFiltro.split('-').map(Number);
      const res = await api.get('/pagos', { params: { mes, anio, limit: 5000 } });
      setPagosFiltrados(res.data.data);
    } catch {}
    finally { setLoading(false); }
  };

  const cargarAuxiliares = async () => {
    try {
      const [cRes, morososRes, paraCorteRes] = await Promise.all([
        api.get('/clientes'),
        api.get('/facturas/morosos'),
        api.get('/facturas/para-corte'),
      ]);
      setClientes(cRes.data);
      setMorosos(morososRes.data);
      setClientesParaCorte(paraCorteRes.data);
    } catch {}
  };

  useEffect(() => { cargarAuxiliares(); }, []);
  useEffect(() => { cargarPagosMes(); }, [mesFiltro]);

  const exportarPagosMes = () => {
    const data = pagosFiltrados.map(p => ({
      'Fecha': new Date(p.createdAt).toLocaleString('es-PE'),
      'Cliente': `${p.cliente?.nombres} ${p.cliente?.apellidos}`,
      'Cobrador': `${p.cobrador?.nombre} ${p.cobrador?.apellido}`,
      'Metodo': p.metodo,
      'Monto': Number(p.monto),
      'Notas': p.notas || '',
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Pagos');
    const buf = XLSX.write(wb, { bookType:'xlsx', type:'array' });
    saveAs(new Blob([buf]), `pagos_${mesFiltro}.xlsx`);
  };

  const exportarClientes = () => {
    const data = clientes.map(c => ({
      'Codigo': c.codigo,
      'Nombres': c.nombres,
      'Apellidos': c.apellidos,
      'DNI': c.dni || '',
      'Telefono 1': c.telefono || '',
      'Telefono 2': c.telefono2 || '',
      'Direccion': c.direccion || '',
      'Zona': c.zona || '',
      'Plan': c.paquete?.nombre || '',
      'Precio': Number(c.paquete?.precio || 0),
      'Estado': c.estado,
      'Fecha inicio': c.fechaInicio?.split('T')[0] || '',
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Clientes');
    const buf = XLSX.write(wb, { bookType:'xlsx', type:'array' });
    saveAs(new Blob([buf]), 'clientes.xlsx');
  };

  const exportarMorosos = () => {
    const data = morosos.map((c: any) => ({
      'Nombres': c.nombres,
      'Apellidos': c.apellidos,
      'DNI': c.dni || '',
      'Telefono 1': c.telefono || '',
      'Telefono 2': c.telefono2 || '',
      'Plan': c.paquete?.nombre || '',
      'Meses deuda': c.mesesDeuda,
      'Deuda total': c.deudaTotal,
      'Estado': c.estado,
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Morosos');
    const buf = XLSX.write(wb, { bookType:'xlsx', type:'array' });
    saveAs(new Blob([buf]), 'morosos.xlsx');
  };

  const exportarParaCorte = () => {
    const meses = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
    const data = clientesParaCorte.map((c: any) => {
      const mesesStr = (c.facturasPendientes || []).map((f: any) => `${meses[(f.mes||1)-1]} ${f.anio||''}`).join(', ');
      return {
        'Codigo': c.codigo,
        'Nombres': c.nombres,
        'Apellidos': c.apellidos,
        'DNI': c.dni || '',
        'Telefono 1': c.telefono || '',
        'Telefono 2': c.telefono2 || '',
        'Direccion': c.direccion || '',
        'Zona': c.zona || '',
        'Plan': c.paquete?.nombre || '',
        'Meses sin pagar': (c.facturasPendientes || []).length,
        'Meses adeudados': mesesStr,
        'Deuda total S/.': Number(c.deudaTotal).toFixed(2),
        'Estado actual': c.estado,
      };
    });
    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = [
      {wch:10},{wch:16},{wch:16},{wch:12},{wch:14},{wch:14},{wch:24},{wch:12},{wch:14},{wch:14},{wch:28},{wch:14},{wch:14}
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Para Corte');
    const buf = XLSX.write(wb, { bookType:'xlsx', type:'array' });
    const fecha = hoy.toISOString().split('T')[0];
    saveAs(new Blob([buf]), `clientes_para_corte_${fecha}.xlsx`);
  };

  const totalMes = pagosFiltrados.reduce((s, p) => s + Number(p.monto), 0);

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>📊 Reportes</h2>
        <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Exportar datos a Excel</p>
      </div>

      {/* Alerta día 8 */}
      {esReporteDia8 && clientesParaCorte.length > 0 && (
        <div style={{ background:'#ef444415', border:'2px solid #ef444455', borderRadius:12, padding:'14px 18px', marginBottom:20, display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:24 }}>🔴</span>
          <div>
            <div style={{ color:'#ef4444', fontWeight:700, fontSize:15 }}>
              Hoy es día {diaHoy} — {clientesParaCorte.length} cliente{clientesParaCorte.length !== 1 ? 's' : ''} listo{clientesParaCorte.length !== 1 ? 's' : ''} para corte
            </div>
            <div style={{ color:'#94a3b8', fontSize:12, marginTop:2 }}>
              Deben 2+ meses y superaron el período de gracia de 7 días. Descarga el reporte para gestionar los cortes.
            </div>
          </div>
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px,1fr))', gap:16, marginBottom:24 }}>

        {/* Reporte pagos por mes */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ fontSize:24, marginBottom:8 }}>💰</div>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16, marginBottom:4 }}>Pagos por mes</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>Todos los cobros del mes seleccionado</div>
          <div style={{ marginBottom:12 }}>
            <input type="month" value={mesFiltro} onChange={e => setMesFiltro(e.target.value)}
              style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', color:'white', fontSize:13, boxSizing:'border-box' as any }} />
          </div>
          <div style={{ background:'#22c55e11', border:'1px solid #22c55e33', borderRadius:8, padding:'10px 14px', marginBottom:12 }}>
            <span style={{ color:'#64748b', fontSize:13 }}>{pagosFiltrados.length} pagos · </span>
            <span style={{ color:'#22c55e', fontWeight:700 }}>S/. {totalMes.toFixed(2)}</span>
          </div>
          <button onClick={exportarPagosMes}
            style={{ width:'100%', background:'#22c55e', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
            📥 Descargar Excel
          </button>
        </div>

        {/* Reporte pagos por cobrador */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ fontSize:24, marginBottom:8 }}>👤</div>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16, marginBottom:4 }}>Pagos por cobrador</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>Total recaudado por cada cobrador en el mes. Subtotales y gran total incluidos.</div>
          <div style={{ marginBottom:12 }}>
            <input type="month" value={mesFiltro} onChange={e => setMesFiltro(e.target.value)}
              style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', color:'white', fontSize:13, boxSizing:'border-box' as any }} />
          </div>
          <button onClick={() => {
            const [anio, mes] = mesFiltro.split('-');
            const url = `${(api.defaults.baseURL || '').replace(/\/$/, '')}/reportes/por-cobrador/excel?mes=${mes}&anio=${anio}`;
            const token = localStorage.getItem('token');
            fetch(url, { headers: { Authorization: `Bearer ${token}` } })
              .then(r => r.blob())
              .then(blob => saveAs(blob, `pagos-por-cobrador-${mes}-${anio}.xlsx`));
          }}
            style={{ width:'100%', background:'#8b5cf6', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
            📥 Descargar Excel
          </button>
        </div>

        {/* Reporte clientes */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ fontSize:24, marginBottom:8 }}>👥</div>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16, marginBottom:4 }}>Lista de clientes</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>Todos los clientes con sus datos y plan</div>
          <div style={{ background:'#0ea5e911', border:'1px solid #0ea5e933', borderRadius:8, padding:'10px 14px', marginBottom:12 }}>
            <span style={{ color:'#38bdf8', fontWeight:700 }}>{clientes.length} clientes registrados</span>
          </div>
          <button onClick={exportarClientes}
            style={{ width:'100%', background:'#0ea5e9', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
            📥 Descargar Excel
          </button>
        </div>

        {/* Reporte morosos */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ fontSize:24, marginBottom:8 }}>⚠️</div>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16, marginBottom:4 }}>Lista de morosos</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>Clientes con facturas vencidas y deuda acumulada</div>
          <div style={{ background:'#ef444411', border:'1px solid #ef444433', borderRadius:8, padding:'10px 14px', marginBottom:12 }}>
            <span style={{ color:'#ef4444', fontWeight:700 }}>
              {morosos.length} morosos
            </span>
          </div>
          <button onClick={exportarMorosos}
            style={{ width:'100%', background:'#ef4444', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
            📥 Descargar Excel
          </button>
        </div>

        {/* Reporte para corte — día 8 */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:`2px solid ${esReporteDia8 && clientesParaCorte.length > 0 ? '#ef4444' : '#334155'}` }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
            <div style={{ fontSize:24 }}>✂️</div>
            {esReporteDia8 && clientesParaCorte.length > 0 && (
              <span style={{ background:'#ef444422', color:'#ef4444', border:'1px solid #ef444444', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:700 }}>
                HOY — DÍA {diaHoy}
              </span>
            )}
          </div>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16, marginBottom:4 }}>Clientes para corte</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>
            Deben 2+ meses y pasaron 7 días de gracia. Este reporte se genera el día 8 de cada mes.
          </div>
          <div style={{ background:'#ef444411', border:'1px solid #ef444433', borderRadius:8, padding:'10px 14px', marginBottom:12 }}>
            <div style={{ color:'#ef4444', fontWeight:700, fontSize:18 }}>{clientesParaCorte.length} clientes</div>
            <div style={{ color:'#94a3b8', fontSize:11, marginTop:2 }}>Con 2+ meses de deuda vencida</div>
          </div>
          {clientesParaCorte.length > 0 ? (
            <button onClick={exportarParaCorte}
              style={{ width:'100%', background:'#ef4444', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
              📥 Descargar Lista de Corte
            </button>
          ) : (
            <button disabled
              style={{ width:'100%', background:'#334155', border:'none', color:'#64748b', borderRadius:8, padding:'10px', cursor:'not-allowed', fontWeight:700 }}>
              Sin clientes para cortar
            </button>
          )}
        </div>

        {/* Reporte pagos por método */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ fontSize:24, marginBottom:8 }}>🏧</div>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16, marginBottom:4 }}>Pagos por método</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>Detalle y resumen de cuánto se cobró por Yape, efectivo, transferencia u otro método</div>
          <div style={{ marginBottom:12 }}>
            <input type="month" value={mesFiltro} onChange={e => setMesFiltro(e.target.value)}
              style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', color:'white', fontSize:13, boxSizing:'border-box' as any }} />
          </div>
          <button onClick={() => {
            const [anio, mes] = mesFiltro.split('-');
            const url = `${(api.defaults.baseURL || '').replace(/\/$/, '')}/reportes/pagos-por-metodo/excel?mes=${mes}&anio=${anio}`;
            const token = localStorage.getItem('token');
            fetch(url, { headers: { Authorization: `Bearer ${token}` } })
              .then(r => r.blob())
              .then(blob => saveAs(blob, `pagos-por-metodo-${mes}-${anio}.xlsx`));
          }}
            style={{ width:'100%', background:'#0f766e', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
            📥 Descargar Excel
          </button>
        </div>

        {/* Reporte averías del mes */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ fontSize:24, marginBottom:8 }}>🔧</div>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16, marginBottom:4 }}>Averías del mes</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>Tipo, estado, técnico y tiempo de resolución por avería</div>
          <div style={{ marginBottom:12 }}>
            <input type="month" value={mesFiltro} onChange={e => setMesFiltro(e.target.value)}
              style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', color:'white', fontSize:13, boxSizing:'border-box' as any }} />
          </div>
          <button onClick={() => {
            const [anio, mes] = mesFiltro.split('-');
            const url = `${(api.defaults.baseURL || '').replace(/\/$/, '')}/reportes/averias/excel?mes=${mes}&anio=${anio}`;
            const token = localStorage.getItem('token');
            fetch(url, { headers: { Authorization: `Bearer ${token}` } })
              .then(r => r.blob())
              .then(blob => saveAs(blob, `averias-${mes}-${anio}.xlsx`));
          }}
            style={{ width:'100%', background:'#7c3aed', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
            📥 Descargar Excel
          </button>
        </div>

        {/* Reporte materiales usados */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ fontSize:24, marginBottom:8 }}>📦</div>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16, marginBottom:4 }}>Materiales usados</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>Consumo de materiales por avería, con resumen por material</div>
          <div style={{ marginBottom:12 }}>
            <input type="month" value={mesFiltro} onChange={e => setMesFiltro(e.target.value)}
              style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', color:'white', fontSize:13, boxSizing:'border-box' as any }} />
          </div>
          <button onClick={() => {
            const [anio, mes] = mesFiltro.split('-');
            const url = `${(api.defaults.baseURL || '').replace(/\/$/, '')}/reportes/materiales/excel?mes=${mes}&anio=${anio}`;
            const token = localStorage.getItem('token');
            fetch(url, { headers: { Authorization: `Bearer ${token}` } })
              .then(r => r.blob())
              .then(blob => saveAs(blob, `materiales-usados-${mes}-${anio}.xlsx`));
          }}
            style={{ width:'100%', background:'#059669', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
            📥 Descargar Excel
          </button>
        </div>
      </div>

      {/* Tabla resumen del mes */}
      <div style={{ background:'#1e293b', borderRadius:12, border:'1px solid #334155', overflow:'hidden' }}>
        <div style={{ padding:'14px 18px', borderBottom:'1px solid #334155' }}>
          <span style={{ color:'#f1f5f9', fontWeight:700, fontSize:15 }}>💵 Pagos de {mesFiltro}</span>
        </div>
        {loading ? <div style={{ textAlign:'center', color:'#64748b', padding:32 }}>Cargando...</div> :
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'#0f172a' }}>
                {['Fecha','Cliente','Cobrador','Metodo','Monto'].map(h => (
                  <th key={h} style={{ padding:'12px 16px', color:'#64748b', fontSize:12, fontWeight:600, textAlign:'left', borderBottom:'1px solid #334155' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pagosFiltrados.map((p) => (
                <tr key={p.id} style={{ borderBottom:'1px solid #0f172a' }}>
                  <td style={{ padding:'10px 16px', color:'#94a3b8', fontSize:12 }}>{new Date(p.createdAt).toLocaleString('es-PE', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' })}</td>
                  <td style={{ padding:'10px 16px', color:'#f1f5f9', fontWeight:600 }}>{p.cliente?.nombres} {p.cliente?.apellidos}</td>
                  <td style={{ padding:'10px 16px', color:'#94a3b8', fontSize:13 }}>{p.cobrador?.nombre} {p.cobrador?.apellido}</td>
                  <td style={{ padding:'10px 16px' }}>
                    <span style={{ background:'#0ea5e922', color:'#38bdf8', border:'1px solid #0ea5e944', borderRadius:20, padding:'3px 8px', fontSize:11 }}>{p.metodo}</span>
                  </td>
                  <td style={{ padding:'10px 16px', color:'#22c55e', fontWeight:700 }}>S/. {Number(p.monto).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        }
        {!loading && pagosFiltrados.length === 0 && <div style={{ textAlign:'center', color:'#64748b', padding:32 }}>Sin pagos en este mes</div>}
      </div>
    </div>
  );
};

export default Reportes;
